"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.replace");

var _ravenJs = _interopRequireDefault(require("raven-js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 资源异常
var MAX_PATH_LEN = 5;

var parse = function parse(path) {
  return path.slice(0, MAX_PATH_LEN).reduce(function (last, target) {
    var tagName = target.tagName,
        className = target.className;
    if (!tagName) return last;
    last.push("".concat(tagName.toLowerCase()).concat(className && ".".concat(className.replace(/\s/g, '.'))));
    return last;
  }, []).join(' > ');
};

var _default = function _default() {
  window.addEventListener('error', function (error) {
    var _error$path = error.path,
        path = _error$path === void 0 ? [] : _error$path,
        target = error.target,
        message = error.message;
    var errMsg = "".concat(target.outerHTML || message || '');
    if (Boolean(_ravenJs.default._globalOptions.ignoreErrors.test) && _ravenJs.default._globalOptions.ignoreErrors.test(errMsg)) return;

    _ravenJs.default.captureException({
      path: parse(path),
      error: errMsg
    });
  }, true);
};

exports.default = _default;